import { render, staticRenderFns } from "./program-information.vue?vue&type=template&id=34345510&"
import script from "./program-information.vue?vue&type=script&lang=js&"
export * from "./program-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports